const projectsData = [
    {
        id: 1,
        title: "transcribGPT",
        description: "an application to convert your audio/video file to transcripts and then have a conversation with ChatGPT about the transcript.",
        link: "https://transcribgpt.com/"
    },
    {
        id: 2,
        title: "smart notes",
        description: "an all-in-one note-taking and equation-solving app for Android",
        link: "https://play.google.com/store/apps/details?id=com.shravanth.smartnotes"
    },
    {
        id: 3,
        title: "weatherify",
        description: "a weather app that integrates with Spotify to create personalized playlists based on the current weather",
        link: "https://github.com/ShravanthReddy/Weatherify"
    },
    {
        id: 4,
        title: "bookmyshow bot",
        description: "a telegram and Python-powered solution that checks the availability of movie tickets",
        link: "https://github.com/ShravanthReddy/Bookmyshow-bot"
    },
    {
        id: 5,
        title: "expense tracker bot",
        description: "a Telegram bot built with Python and MySql database, allowing users to easily track and manage their expenses.",
        link: "https://github.com/ShravanthReddy/ExpenseTrackerBot"
    },
    // {
    //     id: 5,
    //     title: "carpool application",
    //     description: "(In development) a web-based carpooling platform for university students",
    //     link: ""
    // },
    {
        id: 6,
        title: "personal portfolio site",
        description: "a website to showcase my skills",
        link: "https://github.com/ShravanthReddy/portfolio"
    }
]

export default projectsData